import { render, staticRenderFns } from "./ManualOrderForm.vue?vue&type=template&id=496a8768"
import script from "./ManualOrderForm.vue?vue&type=script&lang=js"
export * from "./ManualOrderForm.vue?vue&type=script&lang=js"
import style0 from "./ManualOrderForm.vue?vue&type=style&index=0&id=496a8768&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports